import { useEffect, useRef, useState } from "react";
import { Modal, Tab, Nav } from "react-bootstrap";
import { WithContext as ReactTags } from 'react-tag-input';
import Select from 'react-select';
import ImageUploadBox from "./ImageUploadBox";
import RemoveIcon from "../../../assets/icons/remove.svg"
import { LoadingItem } from "../../../shared/components/loading";
import InfiniteScroll from "react-infinite-scroll-component";
import { AlertMsg } from "../../../shared/components/alert-msg";
import SearchIco from "../../../assets/icons/search.svg"


const uploadProductImage = async ({ pageProps, payload, otherNames, uploadId }: any) => {

    await pageProps.uploadProductImageAction(payload, otherNames, uploadId);
}

const getImagesGallery = async ({ pageProps, payload }: any) => {

    await pageProps.getImageGalleryAction(payload, false);
}

const sizeofFetch = 8;

const getMoreImages = async ({ pageProps, payload }: any) => {

    await pageProps.getImageGalleryAction(payload, true);
}

const ProductImagePopUp = ({ pageProps, showImagesModal, catListItems, hideProductImgModal, tempImages, setUploadImagesData }: any) => {
    const [categoryChosen, setCategoryChosen] = useState<any>();
    const [searchTerm, setSearchTerm] = useState("");
    const [categoryToUpload, setUploadCategory] = useState<any>();
    const [productUploadName, setUploadProductName] = useState("");
    const [productNameError, setProductNameError] = useState(true);
    const [productCatError, setProductCatError] = useState(true);
    const [setImagesUploaded, setImagesUploadedStore] = useState<any>(tempImages ? [...tempImages] : []);
    const [imageData, setImageUploadData] = useState<any>();
    const [hasImageUploaded, setHasImageUploaded] = useState(false);
    const productUploadNameRef = useRef<any>(null);
    const [productUploadOtherNames, setUploadProductOtherNames] = useState<any>([]);
    const [uploadOtherNamesTags, setUploadOtherNamesTags] = useState<any>([]);
    const [showUploadAnother, setShowUploadAnother] = useState(false);
    let imagesChosen: any = [];

    useEffect(() => {

        if (imageData) {
            const imageUploadData = new FormData();
            imageUploadData.append("ProductName", imageData.ProductName);
            imageUploadData.append("CategoryName", imageData.CategoryName);
            imageUploadData.append("ImageFile", imageData.ImageFile);
            imageUploadData.append("OtherNames", imageData.OtherNames);

            uploadProductImage({ pageProps, payload: imageUploadData, otherNames: imageData.OtherNames, uploadId: 'uploading-product-image' })
                .then(() => {
                    setHasImageUploaded(true)

                })
        }

    }, [imageData])

    useEffect(() => {
        uploadProductImage({ pageProps, payload: "CLEAR" })
    }, [])

    useEffect(() => {
        if (hasImageUploaded && pageProps.uploadProductImageRequest.request_status === "UPLOAD_PRODUCT_PICTURE_SUCCESS") {

            let imageLink = pageProps.uploadProductImageRequest.request_data;
            imagesChosen = [...setImagesUploaded]
            imagesChosen.push({
                index: setImagesUploaded.length + 1,
                url: imageLink.response.fileURL,
                otherNames: imageLink?.response?.otherNames ? [...imageLink?.response?.otherNames] : []
                // url: imageLink.response.thumbnail
            })

            let imagesList = [...setImagesUploaded]
            imagesList.push({
                index: setImagesUploaded.length + 1,
                url: imageLink.response.fileURL,
                otherNames: imageLink?.response?.otherNames ? [...imageLink?.response?.otherNames] : []
                // url: imageLink.response.thumbnail
            })
            setImagesUploadedStore(imagesList)

            setHasImageUploaded(false)
        }
    }, [hasImageUploaded])

    const transformImageName = (image: any) => {
        let filename = image;

        if (filename.indexOf("upload-file/") > -1) {
            filename = image.split("upload-file/")[1];
        }
        if (filename.indexOf("thumbnails/") > -1) {
            filename = image.split("thumbnails/")[1];
        }


        return filename;
    }
    const removeImageFromUploads = (chosenImg: any) => {
        let imagesList = [...setImagesUploaded];
        imagesList = imagesList.filter((itemData: any) => {
            return itemData.url !== chosenImg.url
        });
        setImagesUploadedStore(imagesList)
    }

    const saveSearchFilter = (searchTerm: any) => {
        setCategoryChosen({
            label: null,
            value: null
        })
        let payload = `page=1&size=${sizeofFetch}${searchTerm ? `&fileName=${searchTerm}` : ""}`;
        getImagesGallery({ pageProps, payload })
    }

    const saveChosenCat = (chosenCat: any) => {
        setSearchTerm("")
        setCategoryChosen(chosenCat)
        let payload = `page=1&size=${sizeofFetch}${chosenCat?.label ? `&fileName=${chosenCat.label}` : ""}`;
        getImagesGallery({ pageProps, payload })
    }

    const saveUploadCat = (chosenCat: any) => {
        setProductCatError(false)
        setUploadCategory(chosenCat)
    }

    const handleDelete = (i: any) => {
        // this.setState({
        //     tags: this.state.tags.filter((tag, index) => index !== i),
        // });
        setUploadOtherNamesTags(uploadOtherNamesTags.filter((tag: any, index: any) => index !== i))
    }

    const handleAddition = (tag: any) => {

        if (productUploadOtherNames.indexOf(tag?.text) === -1) {
            setUploadOtherNamesTags([...uploadOtherNamesTags, tag])
            setUploadProductOtherNames([...productUploadOtherNames, tag?.text])
        }
        // this.setState({ tags: [...tags, { id: tags.length + 1, text: tag }] });
    }

    const KeyCodes = {
        comma: 188,
        enter: 13
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    return (
        <Modal className="upload_images_wrap" show={showImagesModal} onHide={hideProductImgModal}>
            <Modal.Header closeButton>
                <div className="">Upload product image </div>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container defaultActiveKey="mami_gallery">
                    <Nav className="other_productinfo_tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="upload_now">Upload Image</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="mami_gallery">MamiMarket Gallery</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className="other_productinfo_tabs_content">
                        <Tab.Pane eventKey="upload_now">
                            <div>
                                {pageProps?.uploadProductImageRequest?.request_status === "UPLOAD_PRODUCT_PICTURE_FAILURE" &&

                                    <AlertMsg type="error" message={pageProps?.uploadProductImageRequest?.request_data.error} />
                                }
                                <div className="product-info image-info-details">
                                    <div className="two-sided">
                                        <div className="form-group">
                                            <input placeholder="Product name"
                                                onChange={(e: any) => {


                                                    // setUploadProductName(e.target.value)
                                                }}
                                                onBlur={(e: any) => {
                                                    if (productUploadNameRef?.current?.value.length < 1) {
                                                        // if (e.target.value.trim().length < 1) {
                                                        setProductNameError(true)
                                                    } else {
                                                        setProductNameError(false)
                                                    }
                                                }}
                                                type="text"
                                                // value={productUploadName}
                                                ref={productUploadNameRef}
                                                name="" id=""
                                                className="input-wrap" />
                                            {/* {productNameError &&
                                                <div className="form-input-error" >Required</div>
                                            } */}
                                        </div>

                                        <div className="form-group select-cat-wrap">
                                            <Select
                                                value={categoryToUpload}
                                                onChange={saveUploadCat}
                                                options={catListItems}
                                                placeholder="Category"
                                                className="select-wrap"
                                            />
                                            {/* <select name="" id="">
                                                <option value="">Choose a category</option>
                                                {
                                                    pageProps.getProductMetaDataRequest.request_data.response.categories.map((catItem: any, index: any) => {
                                                        return (
                                                            <option key={index}>{catItem.name}</option>
                                                        )
                                                    })
                                                }
                                            </select> */}
                                            {/* {productCatError &&
                                                <div className="form-input-error">Required</div>
                                            } */}

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <ReactTags
                                            delimiters={delimiters}
                                            tags={uploadOtherNamesTags}
                                            handleDelete={handleDelete}
                                            handleAddition={handleAddition}
                                            classNames={{
                                                tagInput: 'tagInputClass',
                                                tagInputField: 'input-wrap'
                                            }}
                                            placeholder="Other Names of this upload. e.g: Name1, Name2, Name3"
                                        />

                                        <span className="info-txt">**Type Other Name and press enter</span>

                                    </div>
                                </div>
                                {(productNameError || productCatError) &&
                                    <div className="form-input-error text-center">Provide product image name and category before upload</div>
                                }

                                {pageProps?.uploadProductImageRequest?.request_status === "UPLOAD_PRODUCT_PICTURE_PENDING" &&
                                    <LoadingItem />
                                }
                                <ImageUploadBox
                                    productCatError={productCatError}
                                    productUploadNameRef={productUploadNameRef}
                                    categoryToUpload={categoryToUpload} productUploadOtherNames={productUploadOtherNames} setImageUploadData={setImageUploadData} setUploadProductName={setUploadProductName} />


                                {pageProps?.uploadProductImageRequest?.request_status === "UPLOAD_PRODUCT_PICTURE_SUCCESS" &&
                                    <>

                                        {setImagesUploaded.map((eachImage: any, index: any) => (
                                            <div className="progress-indicator" key={index}>
                                                <div className="uploading">
                                                    <div className="file-progress-wrap">
                                                        <div className="filename">{transformImageName(eachImage.url)}</div>
                                                    </div>
                                                    <div className="status-icons">
                                                        <div className="remove-now"
                                                            onClick={() => {
                                                                removeImageFromUploads(eachImage)
                                                            }}
                                                        ><img src={RemoveIcon} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        )
                                        }
                                    </>
                                }
                            </div>
                            {/* <div className="progress-indicator">
                                <div className="uploading">
                                    <div className="file-progress-wrap">
                                        <div className="filename">Tungchivo-avatar.png</div>
                                    </div>
                                    <div className="status-icons">
                                        <div className="remove-now"><img src={RemoveIcon} alt="" /></div>

                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="progress-indicator">
                                <div className="uploading">
                                    <div className="file-progress-wrap">
                                        <div className="filename">Tungchivo-avatar.png</div>
                                        <div className="file-progress">
                                            <div className="percent-width"></div>
                                        </div>
                                        <div className="size-percent">
                                            <div className="sizetxt">428KB</div>
                                            <div className="percent-txt">70%</div>
                                        </div>
                                    </div>
                                    <div className="status-icons">
                                        <div><img src={DoneIcon} alt="" /></div>
                                        <div><img src={RemoveIcon} alt="" /></div>

                                    </div>
                                </div>
                                <div className="uploaded">
                                    <div className="filename-txt">Tungchivo-avatar.png</div>
                                    <div className="size-msg">
                                        428KB
                                        <img src={RemoveIcon} alt="" />
                                    </div>
                                </div>
                            </div> */}
                        </Tab.Pane>
                        <Tab.Pane eventKey="mami_gallery">
                            <div className="search-gallery">
                                <div className="each-filter for-search">
                                    <input type="text"
                                        placeholder="Enter Product title or category"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value)
                                        }}
                                        onBlur={(e) => {
                                            saveSearchFilter(e.target.value.trim())
                                        }} />
                                    <button>
                                        <img src={SearchIco} alt="" />
                                    </button>
                                </div>
                                {(pageProps.getImageGalleryRequest?.galleryData && pageProps.getImageGalleryRequest?.galleryData.length >= 1) &&
                                    <div>
                                        <div className="gallery-head">
                                            <h3>MamiMarket Gallery</h3>
                                            <div className="gallery-txt">Choose from thousands of stunning images..</div>
                                            {/* {
                                                pageProps.getImageGalleryRequest?.request_data?.response?.pageNumber
                                            }
                                            {
                                                pageProps.getImageGalleryRequest?.request_data?.response?.totalNumberOfPages
                                            } */}
                                        </div>
                                        <div className="filter-wrap">
                                            <label htmlFor="">Filter by:</label>
                                            <div className="filter-options">
                                                <Select
                                                    value={categoryChosen}
                                                    onChange={saveChosenCat}
                                                    options={catListItems}
                                                    placeholder="Category"
                                                    className="select-wrap"
                                                    classNamePrefix="gallery-cats"
                                                />

                                            </div>

                                        </div>
                                        <div id="scrollableDiv" style={{ height: 300, overflow: "auto" }}>
                                            <InfiniteScroll
                                                dataLength={pageProps.getImageGalleryRequest?.request_data?.response?.totalNumberOfPages * sizeofFetch}
                                                next={() => {

                                                    let payload = `page=${pageProps.getImageGalleryRequest?.request_data?.response?.totalNumberOfPages + 1}&size=${sizeofFetch}`;
                                                    if (categoryChosen?.label) {
                                                        payload = `${payload}&fileName=${categoryChosen?.label}`;
                                                    }
                                                    if (searchTerm) {
                                                        payload = `${payload}&fileName=${searchTerm}`;
                                                    }


                                                    getMoreImages({ pageProps, payload })
                                                }}
                                                // hasMore={true}
                                                hasMore={
                                                    pageProps.getImageGalleryRequest?.request_data?.response?.pageNumber > pageProps.getImageGalleryRequest?.request_data?.response?.totalNumberOfPages
                                                }
                                                loader={<LoadingItem />}
                                                scrollableTarget="scrollableDiv"
                                            >
                                                {pageProps.getImageGalleryRequest?.galleryData.map((image: any, index: any) => (
                                                    // {pageProps.getImageGalleryRequest?.request_data?.response?.results.map((image: any, index: any) => (
                                                    <div className={`each-image each-image-xy-${index} `} key={index}
                                                        // style={{
                                                        //     backgroundImage: `url(${image.imageUrl})`
                                                        // }}
                                                        onClick={(e) => {
                                                            imagesChosen = [...setImagesUploaded];

                                                            if (!imagesChosen.find((eachImage: any) => eachImage.url === image.imageUrl)) {
                                                                imagesChosen.push({
                                                                    url: image.imageUrl,
                                                                    index,
                                                                    othernames: image?.otherNames ? [...image?.otherNames] : []
                                                                })
                                                                setImagesUploadedStore(imagesChosen)
                                                            } else {
                                                                removeImageFromUploads(image.imageUrl)
                                                                // imagesChosen = imagesChosen.filter((itemData: any) => {
                                                                //     return itemData.url !== image.imageUrl;
                                                                // });
                                                            }


                                                            document.querySelector(`.each-image-xy-${index}`)?.classList?.toggle("chosen-image")

                                                        }}>

                                                        <img
                                                            src={image.imageUrl} alt=""
                                                            className="gallery-img" />

                                                    </div>
                                                ))}

                                            </InfiniteScroll>
                                        </div>

                                    </div>
                                }
                                {pageProps.getImageGalleryRequest.request_status === "GET_IMAGE_GALLERY_PENDING" &&
                                    <LoadingItem />
                                }
                                {pageProps.getImageGalleryRequest.request_status === "GET_IMAGE_GALLERY_FAILURE" &&
                                    <AlertMsg type="error" message={pageProps.getImageGalleryRequest?.request_data.error} />
                                }
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>


            </Modal.Body>
            {(pageProps.getImageGalleryRequest.request_status === "GET_IMAGE_GALLERY_SUCCESS" ||
                pageProps.getImageGalleryRequest.request_status === "GET_IMAGE_GALLERY_NEWBATCH") &&
                <Modal.Footer>
                    <button onClick={() => {
                        setUploadImagesData((prev: any) => [...prev, ...setImagesUploaded])

                        hideProductImgModal();

                    }}> Add to Product</button>
                </Modal.Footer>
            }
        </Modal>
    )
}

export default ProductImagePopUp;